import Billing from "./Billing.vue";
import BillingManagement from "./BillingManagement/BillingManagement.vue";
import { Route } from "vue-router";
import { VersionCheckService } from "@/services/VersionCheckService";

export default {
  path: "/billing",
  component: Billing,
  meta: {
    breadcrumb: "billing"
  },
  children: [
    {
      path: "billing-management",
      name: "BillingManagement",
      component: BillingManagement,
      meta: {
        breadcrumb: "billing"
      },
      beforeEnter: (to: Route, from: Route, next: any) => {
        return VersionCheckService.prototype.versionGuard(to, from, next);
      }
    }
  ]
};
